import { User } from "lucide-react";
import { DriveDeskAIIcon } from "@/components/icons/DriveDeskAIIcon";

/**
 * Your AI Office Manager — single chat message bubble. Kept intentionally
 * dumb (pure presentational) so it's trivially reusable. Uses the
 * branded DriveDeskAIIcon mark (not a generic lucide "Bot" icon) for the
 * assistant avatar, so the brand mark never drifts between surfaces.
 */
export const AIMessageBubble = ({ role, content }) => {
  const isUser = role === "user";
  return (
    <div className={`flex items-start gap-2 ${isUser ? "flex-row-reverse" : ""}`} data-testid={isUser ? "ai-message-user" : "ai-message-assistant"}>
      {isUser ? (
        <div className="h-7 w-7 rounded-full flex items-center justify-center shrink-0 bg-secondary text-foreground">
          <User className="h-3.5 w-3.5" />
        </div>
      ) : (
        <DriveDeskAIIcon className="h-7 w-7" size="sm" variant="circle" />
      )}
      <div
        className={`max-w-[80%] rounded-[var(--radius)] px-3 py-2 text-sm whitespace-pre-wrap break-words ${
          isUser ? "bg-[hsl(var(--role-accent))] text-white" : "bg-secondary text-foreground"
        }`}
      >
        {content || "\u00A0"}
      </div>
    </div>
  );
};
